import React from 'react'
import PropTypes from 'prop-types'
import { i18n } from 'core/i18n'
import { COUNTRIES_CODES } from 'constants/countries'

import './interestBand.scss'

export const InterestBand = ({ tin = '', tae = '', date, grossInterest = '', showStartDateLabel = false, originCountry }) => {
    const { FormattedText } = i18n
    const { PT, NL, DE } = COUNTRIES_CODES

    const showTAE = ![PT, NL, DE].includes(originCountry)

    const poeKeyDate = showStartDateLabel
        ? 'contractsView-contractsView_interestBandStartDate'
        : 'contractsView-contractsView_interestBandEndDate'

    const ulClasses = `interest-band__items${showTAE ? '' : ' interest-band__items--no-tae'}`
    const tinClasses = `interest-band__item${showTAE ? '' : ' interest-band__item--strong'}`

    return (
        <div className="interest-band">
            <ul className={ulClasses}>
                <li className={tinClasses}>
                    <FormattedText value="contractsView-contractsView_interestBandTin" />
                    <span className="interest-band__item__value">{tin}</span>
                </li>
                {
                    showTAE && (
                        <li className="interest-band__item interest-band__item--strong">
                            <div>
                                <FormattedText value="contractsView-contractsView_interestBandTae" />
                            </div>
                            <span className="interest-band__item__value">{tae}</span>
                        </li>
                    )
                }
                <li className="interest-band__item">
                    <FormattedText value={poeKeyDate} />
                    <span className="interest-band__item__value">{date}</span>
                </li>
                <li className="interest-band__item interest-band__item--hightlight interest-band__item--strong">
                    <FormattedText value="contractsView-contractsView_interestBandGrossInterest" />
                    <span className="interest-band__item__value">{grossInterest}</span>
                </li>
            </ul>
        </div>
    )
}

InterestBand.propTypes = {
    tin: PropTypes.string.isRequired,
    tae: PropTypes.string.isRequired,
    date: PropTypes.object.isRequired,
    grossInterest: PropTypes.string.isRequired,
    originCountry: PropTypes.string.isRequired,
    showStartDateLabel: PropTypes.bool
};
